"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.balanceHistory = [
    {
        value: 'topup',
        text: 'Topup'
    },
    {
        value: 'spent',
        text: 'Spent'
    },
    {
        value: 'refund',
        text: 'Refund'
    }
];
var BalanceType;
(function (BalanceType) {
    BalanceType["PRIMARY"] = "primary";
    BalanceType["SECONDARY"] = "secondary";
})(BalanceType = exports.BalanceType || (exports.BalanceType = {}));
//# sourceMappingURL=balance.js.map